import { Injectable } from '@angular/core';
import { HttpWrapperService } from '../common/http-wrapper/http-wrapper.service';
import { Observable } from 'rxjs';
import { IdNamePairViewModel } from '../../models/IdNamePairViewModel';


@Injectable()
export class PreferredMethodOfContactApiService {
    constructor(private httpService: HttpWrapperService ) { }

    public getPreferredMethodOfContacts(): Observable<IdNamePairViewModel[]> {
        return this.httpService.get<IdNamePairViewModel[]>('/articles/preferredcontactmethods');
    }
}
